import { __extends } from "tslib";
import React from 'react';
import { Components } from '@singularsystems/neo-core';
export var FileContext = React.createContext({});
var FileContextProvider = /** @class */ (function (_super) {
    __extends(FileContextProvider, _super);
    function FileContextProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileContextProvider.prototype.render = function () {
        var fileManager = this.props.fileManager;
        if (!fileManager) {
            if (this.props.bind) {
                fileManager = new Components.BoundFileManager(this.props.uploadEndpoint, this.props);
            }
            else {
                fileManager = new Components.FileManager(this.props.uploadEndpoint, this.props);
            }
        }
        return (React.createElement(FileContext.Provider, { value: { fileManager: fileManager } }, this.props.children));
    };
    return FileContextProvider;
}(React.Component));
export default FileContextProvider;
